import { useQuery, useQueries } from '@tanstack/react-query';
import FormCheckbox from '../../shared/FormCheckbox';
import { fetchGetLatestTemplateRiderComponent, fetchTemplateRiderComp } from '../../../utils/apiUtils';
import { getRiderProvisions } from '../../../utils/planUtils';
import ProvisionInfo from './Provision';

const step = 6
const StepSix = ({ activeStep, control, register, setValue, getValues }) => {
  if (activeStep !== step) return;

  const template = getValues("template")
  const vendors = getValues("vendors")

  const { data, isPending } = useQuery({
    queryKey: ['getVendors'],
    // queryFn: async () => await fetchTemplateRiderComp({
    //   size: 100,
    //   benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
    //   searchText: 'Vendor ',
    //   filterText: 'Invoices'
    // }),
    // select: (results) => results.hits.hits.map(hit => hit._source.metadata),

    queryFn: async () => await fetchGetLatestTemplateRiderComponent({

      benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
      searchText: 'Vendor ',
      limit: 100
    }),
    select: (data) => data.rows.filter(r => !r.benefitPlanRiderHccId?.includes('Invoices')),

    // staleTime: Infinity,
    enabled: !!template?.additional?.benefitPlanTemplateKey,
  })
  const selectedRiders = (data || []).filter(r => !!vendors[r.benefitPlanRiderName])

  const { data: ridersWithProvisions, isPending: provisionsPending } = useQueries({
    queries: selectedRiders.map(rider => ({
      queryKey: ['provisions', rider.benefitPlanRiderName],
      queryFn: async () => await getRiderProvisions(rider.bnftPlanCompHistFactKey),
      select: (provisions) => ({ ...rider, provisions }),
      staleTime: Infinity,
    })),
    combine: (results) => ({
      data: results.map(r => r.data),
      isPending: results.some(r => r.isPending),
    }),
  })

  return (
    <>
      {isPending ?
        <div className="loader" />
        :
        <>
          {data?.sort((a, b) => a.benefitPlanRiderHccId?.localeCompare(b.benefitPlanRiderHccId))
            .map(vendor => (
              <FormCheckbox
                key={vendor.benefitPlanRiderHccId}
                label={`${vendor.benefitPlanRiderHccId?.replace('Vendor -', '')} `}
                name={`vendors.${vendor.benefitPlanRiderHccId}`}
                register={register}
                control={control}
                onSelectedHandler={(checked) => {
                  if (checked) {
                    setValue(`vendors.${vendor.benefitPlanRiderHccId}`, {
                      value: vendor.benefitPlanRiderHccId,
                      label: `${vendor.benefitPlanRiderHccId}`,
                      additional: vendor,
                    });
                  } else {
                    setValue(`vendors.${vendor.benefitPlanRiderHccId}`, undefined);
                  }
                }}
              />
            ))}
        </>
      }

      <h4 style={{ paddingTop: '1.5rem' }}>Provisions:</h4>
      {provisionsPending ?
        <div className="loader" />
        :
        <>
          {ridersWithProvisions.map((r, i) => <ProvisionInfo key={i} rider={r} />)}
        </>
      }
    </>
  )
}

export default StepSix
